import { render } from "./InvoiceSharing.vue?vue&type=template&id=68d640e7&scoped=true"
import script from "./InvoiceSharing.vue?vue&type=script&lang=js"
export * from "./InvoiceSharing.vue?vue&type=script&lang=js"

import "./InvoiceSharing.vue?vue&type=style&index=0&id=68d640e7&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68d640e7"]])

export default __exports__